import { ApplicationStatus } from '@core/types';

const STATUS_CONFIG: Record<ApplicationStatus, { label: string; className: string }> = {
  submitted:              { label: 'Submitted',          className: 'badge-submitted' },
  viewed_by_client:       { label: 'Viewed',             className: 'badge-submitted' },
  shortlisted:            { label: 'Shortlisted',        className: 'badge-shortlisted' },
  interview_1_scheduled:  { label: 'Interview 1 Sched.', className: 'badge-interview' },
  interview_1_conducted:  { label: 'Interview 1 Done',   className: 'badge-interview' },
  interview_2_scheduled:  { label: 'Interview 2 Sched.', className: 'badge-interview' },
  interview_2_conducted:  { label: 'Interview 2 Done',   className: 'badge-interview' },
  offer_extended:         { label: 'Offer Extended',     className: 'badge-offer' },
  offer_accepted:         { label: 'Offer Accepted',     className: 'badge-shortlisted' },
  offer_rejected:         { label: 'Offer Rejected',     className: 'badge-rejected' },
  placed:                 { label: 'Placed ✓',           className: 'badge-shortlisted' },
  rejected:               { label: 'Rejected',           className: 'badge-rejected' },
  no_show:                { label: 'No Show',             className: 'badge-no_show' },
  on_hold:                { label: 'On Hold',             className: 'badge-on_hold' },
  closed:                 { label: 'Closed',              className: 'badge-rejected' },
};

interface StatusBadgeProps {
  status: ApplicationStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? { label: status, className: 'badge-submitted' };
  return <span className={config.className}>{config.label}</span>;
}
